<template>
  <div class="browser-not-supported">
    Sorry, your browser is not supported. Please use the latest version of
    <a href="https://www.google.com/chrome/">Chrome</a> or <a href="https://www.apple.com/safari/">Safari</a> for the
    best experience.
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@use '@common/style/variables.scss' as *;

.browser-not-supported {
  position: fixed;
  left: 0;
  z-index: 3;
  width: 100%;
  top: $main-menu-height;
  background: $error-color;
  color: white;
  padding: calc(#{$browser-not-supported-height} / 2) 20px;
  padding-right: 40px;
  a {
    color: white;
    text-decoration: underline;
  }
}
@media only screen and (max-width: $main-menu-breakpoint) {
  .browser-not-supported {
    top: $main-menu-height-mobile;
  }
}
</style>
